'use client';
import React, { FC, memo, ReactNode } from 'react';
import styles from './index.module.scss';
import cls from 'classnames';
import { Button } from '@bfe/moly';
import { faqClick } from '@/config/sensor';

export interface Props {
  title?: ReactNode;
  content?: ReactNode;
  action?: ReactNode;
  onAction?: () => void;
}

const Faq: FC<Props> = ({ title, action, onAction }) => {
  return (
    <div className={styles.faqWrapper}>
      <div className={cls(styles.faq)}>
        <div className={styles.title}>FAQ</div>
        {action ? (
          <div className={styles.btn}>
            <Button
              variant="primary"
              onClick={() => {
                faqClick();
                onAction?.();
              }}
            >
              {action}
              <i
                className="moly-iconfont bit-a-icon_directionright"
                style={{ paddingLeft: 4 }}
              />
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default memo(Faq);
